<template>
   <v-container grid-list-md fluid>
      <!-- part 1 create DO  -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10" color="blue-grey lighten-5">
            <do_main_table></do_main_table>
          </v-card>
        </v-flex>
      </v-layout>
   </v-container>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import do_main_table from "@/components/datatables/Do_main_table";
export default {
    components: {
    //VWidget,
    do_main_table
  },
  data: () => ({
  
  }),

  computed: {},

  watch: {

  
  },

  created() {},

  methods: {
 
  }
};
</script>
